export enum ReadAloudPlayerType {
  WITH_PAUSE = 'WITH_PAUSE',
  NO_PAUSE = 'NO_PAUSE',
  NO_PAUSE_OUTER_CLICK = 'NO_PAUSE_OUTER_CLICK',
}
